module.exports = __webpack_public_path__ + "static/media/back.019a4d82.jpg";